<template>
    <Map class="animated fadeIn" type="Nước dưới đất" />
</template>

<script>
import Map from '@/components/Map';

export default {
    components: {
        Map
    }
};
</script>
